import React from "react";
import { CheckIcons, XIcon } from "../../assets/svgs/icons-svg";

type StepStatus = 'pending' | 'active' | 'done' | 'error'

export function StepIndicator({ label, status }: { label: string; status: StepStatus }) {
  const bg = {
    done: 'bg-gray-900',
    active: 'bg-gray-900',
    error: 'bg-red-500',
    pending: 'bg-gray-300',
  }[status]

  return (
    <div className="flex items-center gap-2 select-none">
      <div className={`w-7 h-7 rounded-full flex items-center justify-center transition-all duration-300 ${bg}`}>
        {status === 'done' && <CheckIcons />}
        {status === 'active' && <CheckIcons />}
        {status === 'error' && <XIcon />}
      </div>
      <span className={`text-sm font-medium transition-colors duration-200 ${status === 'pending' ? 'text-gray-400' : 'text-gray-900'}`}>
        {label}
      </span>
    </div>
  )
}